"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";

export default function LoginPage() {
  const router = useRouter();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit() {
    setError("");
    setLoading(true);

    try {
      const res = await fetch("/api/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });

      if (!res.ok) {
        const data = await res.json();
        setError(data.error || "Login failed");
        return;
      }

      router.push("/editor");
    } catch {
      setError("An unexpected error occurred");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center relative">
      {/* Floating orbs */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -left-40 w-[500px] h-[500px] bg-purple-600/15 rounded-full blur-[120px]" />
        <div className="absolute -bottom-40 -right-40 w-[500px] h-[500px] bg-emerald-500/10 rounded-full blur-[120px]" />
        <div className="absolute top-1/3 right-1/4 w-[300px] h-[300px] bg-indigo-500/8 rounded-full blur-[80px]" />
      </div>

      <div className="w-full max-w-sm relative z-10 animate-fade-in">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl glass-card mb-4">
            <span className="text-2xl font-bold bg-gradient-to-br from-purple-400 to-emerald-400 bg-clip-text text-transparent">22</span>
          </div>
          <h1 className="text-3xl font-bold text-white tracking-tight">
            DOC 22
          </h1>
          <p className="text-sm text-white/40 mt-1">Voorsteldocument Editor</p>
        </div>

        <div
          className="glass-card rounded-2xl p-8 space-y-5"
        >
          {error && (
            <div className="bg-red-500/10 backdrop-blur-sm text-red-400 text-sm rounded-xl p-3 border border-red-500/20">
              {error}
            </div>
          )}

          <div>
            <label
              htmlFor="username"
              className="block text-xs font-medium text-white/50 mb-1.5 uppercase tracking-wider"
            >
              Gebruikersnaam
            </label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              className="w-full rounded-xl glass-input px-4 py-2.5 focus:outline-none"
              placeholder="Voer gebruikersnaam in"
            />
          </div>

          <div>
            <label
              htmlFor="password"
              className="block text-xs font-medium text-white/50 mb-1.5 uppercase tracking-wider"
            >
              Wachtwoord
            </label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full rounded-xl glass-input px-4 py-2.5 focus:outline-none"
              placeholder="Voer wachtwoord in"
            />
          </div>

          <button
            type="button"
            disabled={loading}
            onClick={handleSubmit}
            className="w-full bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-500 hover:to-indigo-500 disabled:opacity-50 text-white font-medium py-2.5 px-4 rounded-xl transition-all duration-200 shadow-lg shadow-purple-600/20 hover:shadow-xl hover:shadow-purple-500/30 active:scale-[0.98]"
          >
            {loading ? "Inloggen..." : "Inloggen"}
          </button>
        </div>
      </div>
    </div>
  );
}
